<template>
  <el-select
    v-model="selected"
    :disabled="disabled"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestCustomers"
    :loading="loading"
    placeholder="请搜索并选择"
    :popper-append-to-body="false"
    class="long"
    style="width: 100%"
  >
    <el-option
      v-for="item in customers"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { customerList } from '../../service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: '',
    dealerID: 0,
    filterCustomerID: 0,
    category: 0,
    area: {
      type: Array,
      default: () => [],
    },
    disabled: false,
    isNotFinalCustomer: false,
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else {
        this.requestDefaultCustomer()
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      customers: [],
      loading: false,
      addCustomerFormVisible: false,
    }
  },
  created() {
    if (this.val > 0) {
      this.requestDefaultCustomer()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
    },
    createdCustomer(res) {
      this.customers.push(res)
      this.selected = res.id
      this.$emit('change', parseInt(this.selected) || 0)
    },
    async requestDefaultCustomer() {
      let res = await customerList({ customer_id: this.val, special_mark: -1 })
      this.customers = res.data.list.map((item) => {
        if (item.sap_code) {
          item.name += `（${item.sap_code}）`
        }
        return item
      })

      let that = this
      this.$nextTick(() => {
        that.selected = that.val
      })
    },
    async requestCustomers(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          name: query,
          dealer_id: this.dealerID || 0,
          category: this.category || 0,
          page: 0,
          size: 20,
          special_mark: -1,
          is_not_final_customer: this.isNotFinalCustomer || false,
        }
        let res = await customerList(data)
        this.loading = false
        res.data.list = res.data.list.filter(
          (item) => item.id != this.filterCustomerID
        )
        this.customers = res.data.list.map((item) => {
          if (item.sap_code) {
            item.name += `（${item.sap_code}）`
          }
          return item
        })
      } else {
        this.customers = []
      }
    },
  },
}
</script>